<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <app-base-main parentTable>
        <template #filter-group>
            <app-filter-group
                    @query="$gjNoticeQuery"
                    @reset="$gjReset">

                <gj-warehouse-select
                        v-model="filter.warehouseIds"
                        multiple
                        width="180px"
                ></gj-warehouse-select>

                <gj-select-input
                        v-model="filter.keyword"
                        :options="[
                       {id: 'sku', text: 'SKU'},
                       {id: 'msku', text: 'MSKU'}
                   ]"
                >
                </gj-select-input>

                <template #right>
                  <gj-tool-group help></gj-tool-group>
                    <gj-tool-group
                            setting :table-name="tableName"
                            :table-columns="columns"
                            :sort-gjtable="$refs.gjTable"
                            :download="$permission('fbaRestock:export')"
                            download-url="/operation/fbaRestock/export"
                            :download-params="globalParams"
                    >
                    </gj-tool-group>
                </template>
            </app-filter-group>
        </template>
        <template #table>
            <gj-table
                    ref="gjTable"
                    adaptParent
                    :name="tableName"
                    :data="tableData"
                    :columns="columns"
                    :loading="loading"
                    sortable="custom"
                    show-summary
                    :default-sort="{prop: 'impressions', order: 'descending'}"
                    :size="'has-picture'"
                    :pagination="pagination"
                    @sort-change="$gjSortChange"
                    @page-change="$gjNoticeQuery">
                <template v-slot:sku="{row}">
                    <div>
                        <div class="text-ellipsis-1">{{row.skuName}}</div>
                        <RelateProductComponent :data="row" />
                    </div>
                </template>
<!--                <template v-slot:msku="{row}">-->
<!--                    <div>-->
<!--                        <div class="text-ellipsis-1">{{row.asin}}</div>-->
<!--                        <div class="text-ellipsis-1">{{row.msku}}</div>-->
<!--                    </div>-->
<!--                </template>-->
            </gj-table>
        </template>
    </app-base-main>

</template>

<script>
    import {queryMixin} from "@/minxins";
    import {exportFbaRestock, getFbaRestockPage} from "@/api/statistics";
    import {isMeaningful} from "@/utils/common";
    import {sumField} from "@/utils/common";
    import { RelateProductComponent }from '@/views/components/relate-product/index'

    export default {
        name: "app-fbaRestore",
        mixins: [queryMixin],
        components: {
            RelateProductComponent
        },
        data() {
            return {
                tableName: 'fbaRestore',
                columns: [
                    // id: 字段ID，用于优化渲染以及自定义列，必填
                    // header: 表头名称结构为：slot:slotName:name（slot: 是否插槽，slotName: 引用的插槽名，name：表头名称，用于自定义列的表头名）
                    // field: 字段内容域，类型为数据字段名或slot
                    // help: 帮助信息（问号）
                    // notCustomColumn: 是否是自定义字段，默认：false
                    // default: 是否自定义列默认字段
                    // {marketName: 'aa', asin: 'asin1'}
                    {id: 'warehouseName', header: '仓库', field: 'warehouseName', minWidth: '120px', overflowLine: 2, sortable: true, sortBy: 'warehouseId', default: true, disabled: true, fixed: "left"},
                    {id: 'imageUrl', header: '图片', field: 'picture:imageUrl', minWidth: '70px', default: true, fixed: "left"},
                    {id: 'msku', header: 'MSKU', field: 'msku', minWidth: '140px', sortable: true, overflowLine: 1, default: true, fixed: "left"},
                    {id: 'fnsku', header: 'FNSKU', field: 'fnsku', sortable: true, minWidth: '110px', default: true},
                    {id: 'sku', header: '产品名称/SKU', field: 'slot:sku', minWidth: '185px', sortable: true, default: true},
                    {id: 'asin', header: 'ASIN', field: 'asin', minWidth: '140px', sortable: true, default: true},
                    {id: 'categoryName', header: '品类', field: 'categoryName', minWidth: '100px', default: true},
                    {id: 'brandName', header: '品牌', field: 'brandName', minWidth: '100px', default: true},
                    {id: 'salesLastThirtyDays', header: '近30天销售额', field: 'salesLastThirtyDays', prefix: 'currencySymbol', sortable: true, minWidth: '130px', align: 'right', default: true},
                    {id: 'unitsSoldLastThirtyDays', header: '近30天销量', field: 'unitsSoldLastThirtyDays', sortable: true, minWidth: '110px', align: 'right', default: true, summary: true},
                    {id: 'totalUnits', header: '总库存', field: 'totalUnits', sortable: true, minWidth: '90px', align: 'right', default: true,
                        summary: true, summaryBy: 'totalUnits', summaryMethod: (tableData) => {
                            return sumField(tableData, 'totalUnits');
                        }},
                    {id: 'inbound', header: '入库量', field: 'inbound', sortable: true, minWidth: '90px', align: 'right', default: true, summary: true},
                    {id: 'available', header: '可售量', field: 'available', sortable: true, minWidth: '90px', align: 'right', default: true, summary: true},
                    {id: 'customerOrder', header: '买家订单', field: 'customerOrder', sortable: true, minWidth: '90px', align: 'right', default: true, summary: true},
                    {id: 'fcTransfer', header: '调拨中', field: 'fcTransfer', sortable: true, minWidth: '90px', align: 'right', default: true, summary: true},
                    {id: 'fcProcessing', header: '处理中', field: 'fcProcessing', sortable: true, minWidth: '90px', align: 'right', default: true, summary: true},
                    {id: 'unfulfillable', header: '不良品量', field: 'unfulfillable', sortable: true, minWidth: '90px', align: 'right', default: true, summary: true},
                    {id: 'daysOfSupply', header: '预计可售天数', field: 'daysOfSupply', sortable: true, minWidth: '110px',  align: 'right', default: true, summary: true},
                    {id: 'alert', header: '预警信息', field: 'alert', minWidth: '150px', default: true},
                    {id: 'recommendedReplenishmentQty', header: '推荐补货量', field: 'recommendedReplenishmentQty', sortable: true, minWidth: '100px', align: 'right', default: true, summary: true},
                    {id: 'recommendedShipDate', header: '推荐补货时间', field: 'recommendedShipDate', sortable: true, minWidth: '120px', default: true},
                    {id: 'currentMonthMaxInventory', header: '当月最高库存阈值', field: 'currentMonthMaxInventory', sortable: true, minWidth: '140px', align: 'right', default: true, summary: true},
                    {id: 'utilization', header: '库存限额使用量', field: 'utilization', sortable: true, minWidth: '130px', align: 'right', default: true, summary: true},
                    {id: 'maxShipmentQuantity', header: '最大发货量', field: 'maxShipmentQuantity', sortable: true, minWidth: '110px', align: 'right', default: true, summary: true},
                ],
                tableData: [],
                filter: {
                    warehouseIds: "",
                    keyword: {
                        key: 'sku',
                        value: null
                    },
                },
                modalVisible: {
                    logModal: false,
                    detailModal: false,
                    clickDownload: false,
                },
                notStorage: true
            }
        },
        created() {
            this.sort.prop = null;
        },
        methods: {
            $gjQueryInitParams() {
                return {
                    filter: {
                        warehouseIds: null,
                        keyword: {
                            key: 'sku',
                            value: null
                        },
                    },
                };
            },
            $gjQuery() {
                // 构造查询参数
                const params = {
                    model: {
                        warehouseIds: this.filter.warehouseIds
                    },
                    ...this.queryPagination,
                    ...this.querySort
                };
                params.model[this.filter.keyword.key] = this.filter.keyword.value;
                this.globalParams = params;
                // 查询
                this.loading = true;
                getFbaRestockPage(params)
                    .then((data) => {
                        if (isMeaningful(data)) {
                            this.tableData = data.records;

                            this.pagination = this.getPagination(data);
                        }
                    })
                    .complete(() => {
                        this.loading = false;
                    })
            },
        },
    }
</script>

<style scoped>

</style>
